module.exports = __webpack_public_path__ + "collaboration.png?3f7b574e74fca89c3cd18bcc61738cdb";